import { environment } from "src/environments/environment";

export class ConstantsRealTimeSegments {
  public static readonly deleteTriggersSegmentsCacheUrl = `${environment.segmentsAPI.baseURL}/cache/triggers/segments`;
  public static readonly deleteDatasourceSegmentsCacheUrl = `${environment.segmentsAPI.baseURL}/cache/datasource/segments`;
  public static readonly deleteWidgetsSegmentsCacheUrl = `${environment.segmentsAPI.baseURL}/cache/widgets/segments`;
}
